import React from "react";

const MilestoneFormSkeleton: React.FC = () => {
  return (
    <form className="px-6 pt-4 flex-1 overflow-auto animate-pulse">
      <div className="space-y-5 h-[50rem]">
        {/* Intro text */}
        <div>
          <div className="h-4 w-3/4 bg-gray-200 rounded mb-2" />
          <div className="h-4 w-full bg-gray-200 rounded mb-2" />
        </div>

        {/* Milestone name */}
        <div>
          <div className="h-4 w-40 bg-gray-200 rounded mb-3" />
          <div className="h-12 w-full bg-gray-200 rounded-md" />
        </div>

        {/* Milestone description */}
        <div>
          <div className="h-4 w-48 bg-gray-200 rounded mb-3" />
          <div className="h-28 w-full bg-gray-200 rounded-md" />
        </div>

        {/* Start/End Dates */}
        <div className="flex gap-4">
          <div className="w-1/2">
            <div className="h-4 w-32 bg-gray-200 rounded mb-3" />
            <div className="h-12 w-full bg-gray-200 rounded-md" />
          </div>
          <div className="w-1/2">
            <div className="h-4 w-28 bg-gray-200 rounded mb-3" />
            <div className="h-12 w-full bg-gray-200 rounded-md" />
          </div>
        </div>

        {/* Reporting frequency */}
        <div>
          <div className="h-4 w-52 bg-gray-200 rounded mb-3" />
          <div className="flex gap-4">
            <div className="w-1/2 h-10 bg-gray-200 rounded-md" />
            <div className="w-1/2 h-10 bg-gray-200 rounded-md" />
          </div>
        </div>

        {/* Projects */}
        <div>
          <div className="h-4 w-24 bg-gray-200 rounded mb-3" />
          <div className="h-12 w-full bg-gray-200 rounded-lg" />
          <div className="h-4 w-72 bg-gray-200 rounded mt-2" />
        </div>

        {/* Reporting template */}
        <div>
          <div className="h-4 w-40 bg-gray-200 rounded mb-3" />
          <div className="h-10 w-full bg-gray-200 rounded-md" />
        </div>

        {/* Responsible */}
        <div className="mb-5">
          <div className="h-4 w-28 bg-gray-200 rounded mb-3" />
          <div className="h-12 w-full bg-gray-200 rounded-lg" />
        </div>
      </div>
    </form>
  );
};

export default MilestoneFormSkeleton;
